import PasswordStrengthChecker from "./PasswordStrengthChecker";

export default PasswordStrengthChecker;